export const RUN_AS_CURRENT_USER_CONTEXT_TYPE = 'currentUser' as const;
export const RUN_AS_PROJECT_DEFAULT_CONTEXT_TYPE = 'projectDefault' as const;

export type RunAsUserContextType =
	| typeof RUN_AS_CURRENT_USER_CONTEXT_TYPE
	| typeof RUN_AS_PROJECT_DEFAULT_CONTEXT_TYPE;

export type RunAsUserContext = {
	type: RunAsUserContextType;
};

export type ProjectContext = {
	projectId: number;
};

export type ProjectRunAsUser = {
	accountId: string;
	userDisplayName?: string;
	isValid: boolean;
};

export type RuleSetLink = {
	href: string;
	rel: string;
};

export type BlueprintModuleKey = string;
export type RuleSetId = string;

export const customBlueprintModuleKey: BlueprintModuleKey =
	'com.atlassian.servicedesk.plugins.automation.servicedesk-automation-modules-plugin:sd-automation-blank-blueprint';

export type SummaryBlueprint = {
	moduleKey: BlueprintModuleKey;
	name: string;
	iconPath?: string;
	description?: string;
};

type SummaryWhenHandlerSummary = {
	name: string;
	iconClass: string;
	type: string;
};

type SummaryRuleSetMetadata = {
	projectContext: ProjectContext;
	triggerFromOtherRules: boolean;
	projectRunAsUser: ProjectRunAsUser;
	runAsUserContext?: RunAsUserContext;
};

export type SummaryRuleSet = {
	id: RuleSetId;
	name: string;
	description?: string;
	link: RuleSetLink;
	whenSummary: {
		whenHandlerSummaries: SummaryWhenHandlerSummary[];
	};
	metadata: SummaryRuleSetMetadata;
	validation: {
		errors: string[];
	};
	enabled: boolean;
};

export type SummaryEntities = {
	blueprints: Record<BlueprintModuleKey, SummaryBlueprint>;
	ruleSets: Record<RuleSetId, SummaryRuleSet>;
};

export type SummaryRunAsUserSettings = {
	isSet: boolean;
	isUpdated: boolean;
	config?: {
		type: string;
		user: ProjectRunAsUser;
	};
};

export type SummaryResult = {
	blueprints: BlueprintModuleKey[];
	ruleSets: RuleSetId[];
	projectRunAsUserSettings: SummaryRunAsUserSettings;
};

export type SummaryPage = {
	entities: SummaryEntities;
	result: SummaryResult;
};
